import { render, staticRenderFns } from "./PhaserCanvas.vue?vue&type=template&id=c0d4a07e&scoped=true&"
import script from "./PhaserCanvas.vue?vue&type=script&lang=js&"
export * from "./PhaserCanvas.vue?vue&type=script&lang=js&"
import style0 from "./PhaserCanvas.vue?vue&type=style&index=0&id=c0d4a07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d4a07e",
  null
  
)

export default component.exports